/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateProfileUrlRequestDto
 */
export interface UpdateProfileUrlRequestDto {
    /**
     * Profile image URL
     * @type {string}
     * @memberof UpdateProfileUrlRequestDto
     */
    photoUrl?: string;
}

/**
 * Check if a given object implements the UpdateProfileUrlRequestDto interface.
 */
export function instanceOfUpdateProfileUrlRequestDto(value: object): value is UpdateProfileUrlRequestDto {
    return true;
}

export function UpdateProfileUrlRequestDtoFromJSON(json: any): UpdateProfileUrlRequestDto {
    return UpdateProfileUrlRequestDtoFromJSONTyped(json, false);
}

export function UpdateProfileUrlRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateProfileUrlRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'photoUrl': json['photoUrl'] == null ? undefined : json['photoUrl'],
    };
}

export function UpdateProfileUrlRequestDtoToJSON(json: any): UpdateProfileUrlRequestDto {
    return UpdateProfileUrlRequestDtoToJSONTyped(json, false);
}

export function UpdateProfileUrlRequestDtoToJSONTyped(value?: UpdateProfileUrlRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'photoUrl': value['photoUrl'],
    };
}

